import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

export const HeadReportContractsToInstallmentsPDF = () => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: { width: "8%", textAlign: "center" },
      title: "Parcela",
    },
    {
      style: { width: "8%", textAlign: "center" },
      title: "Vidas",
    },
    {
      style: { width: "12%", textAlign: "right" },
      title: "Data Venc.",
    },
    {
      style: { width: "12%", textAlign: "right" },
      title: "Data Recebida",
    },
    {
      style: { width: "10%", textAlign: "center" },
      title: "Parc. Recebida",
    },
    {
      style: { width: "13%", textAlign: "right" },
      title: "Valor Parc.",
    },
    {
      style: { width: "14%", textAlign: "right" },
      title: "Mensalidade paga",
    },
    {
      style: { width: "11%", textAlign: "right" },
      title: "Valor Diverg.",
    },
    {
      style: { width: "12%", textAlign: "right" },
      title: "Lucro Parc.",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
